/**
 * Created by vladislav on 4/22/2024
 */

// eslint-disable-next-line no-unused-vars
const connector = {};

window.connector = connector;

connector.SDK_NAME = "connector";

connector.AMAZON = "amazon";
connector.ANDROID = "android";
connector.APPLE = "apple";
connector.CLEVERAPPS = "cleverapps";
connector.LABSYSTECH = "labsystech";
connector.CRAZY = "crazy";
connector.DRAUGIEM = "draugiem";
connector.FACEBOOK = "facebook";
connector.FOTOSTRANA = "fotostrana";
connector.GDCOM = "gdcom";
connector.COOLMATHGAMES = "coolmath";
connector.GPG = "gpg";
connector.INSTANT = "instant";
connector.IOS = "ios";
connector.KONGREGATE = "kongregate";
connector.MACOS = "macos";
connector.MICROSOFT = "microsoft";
connector.MSIX = "msix";
connector.G5WINDOWS = "g5windows";
connector.MOBAGE = "mbga";
connector.SP_MOBAGE = "sp_mbga";
connector.MSSTART = "msstart";
connector.MYGAMES = "mygames";
connector.MM = "mm";
connector.OK = "ok";
connector.OKBRIDGE = "okbridge";
connector.DIGITAL = "digital";
connector.DIGITALWEB = "digitalweb";
connector.EPICGAMES = "epicgames";
connector.PLINGA = "plng";
connector.PWA = "pwa";
connector.RUSTORE = "rustore";
connector.ONESTORE = "onestore";
connector.SAMSUNG = "samsung";
connector.TEST = "test";
connector.VK = "vk";
connector.WECHAT = "wechat";
connector.XIAOMI = "xiaomi";
connector.YANDEX = "yandex";
connector.YOUTUBE = "youtube";
connector.GAMESNACK = "gamesnack";
connector.DISCORD = "discord";
connector.TELEGRAM = "telegram";
connector.MSPWA = "mspwa";
connector.REDDIT = "reddit";
connector.TIKTOK = "tiktok";
connector.ARKADIUM = "arkadium";
connector.ADDICTINGGAMES = "addicting";
connector.POGO = "pogo";

connector.XSOLLA = "xsolla";
connector.IAP = "iap";
connector.YOOKASSA = "yookassa";
connector.ROBOKASSA = "robokassa";

connector.AD_MOB = "ad_mob";
connector.APP_LOVIN = "app_lovin";
connector.GOOGLE_ADS = "google_ads";
connector.CLEVERAPPS_GOOGLE_ADS = "cleverapps_google_ads";
connector.PORTAL_YANDEX_ADS = "portal_yandex_ads";
connector.MULTI_ADS = "multi_ads";
connector.YANDEX_APP_ADS = "yandex_app_ads";
connector.YANDEX_WEB_ADS = "yandex_web_ads";

connector.MULTI_SOCIAL = "multi_social";

connector.NONE = "none";